<template>
  <div class="forward" style="float: left; margin-right: 10px">
    <Button @click="openGroupModal" type="primary">转发</Button>
    <!-- 弹窗表单 -->
    <Modal
      title="公文转发"
      @on-ok="hendelTransferOffice"
      v-model.trim="transferOfficeModel"
      draggable
      width="600"
    >
      <!-- <div class="modal-content">
        <Select
          clearable
          filterable
          placeholder="选择转办人"
          style="width: 180px"
          v-model="transferOfficeMeb"
          label-in-value
          multiple
        >
          <Option
            v-for="item in merberList"
            :value="item.f_id"
            :key="item.f_id"
          >
            {{ item.f_realname }}
          </Option>
        </Select>
      </div> -->
      <!-- 查询条件 -->
      <div class="search-div" style="margin-bottom: 20px">
        <div style="display: flex">
          <Form inline>
            <FormItem label="选择群组">
              <Select
                v-model="groupId"
                clearable
                filterable
                placeholder="选择群组"
                label-in-value
                multiple
                @on-change="handleSearchGroup"
              >
                <Option
                  v-for="item in groupList"
                  :value="item.group_id"
                  :key="item.group_id"
                >
                  {{ item.group_name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem label="添加成员">
              <Select
                v-model="transferOfficeMeb"
                clearable
                filterable
                placeholder="选择成员"
                label-in-value
                @on-change="handleChangeMeb"
              >
                <Option
                  v-for="item in mebData"
                  :value="item.f_id"
                  :key="item.f_id"
                >
                  {{ item.f_realname }}
                </Option>
              </Select>
            </FormItem>
          </Form>

          <!-- 操作按钮 -->
          <!-- <Button
            style="margin-left: 20px"
            class="btn"
            type="success"
            @click="handleSearchGroup"
          >
            添加
          </Button> -->
        </div>
        <!-- <a @click="showOtherSearch = !showOtherSearch">
            {{ this.showOtherSearch ? '隐藏' : '更多条件' }}
          </a> -->
      </div>
      <div style="max-height: 450px; overflow: auto">
        <Table
          :columns="groupColumns"
          :data="groupData"
          :loading="tableLoading"
        >
          <template #action="{ row }">
            <Button
              type="error"
              size="small"
              style="margin-right: 5px"
              @click="handleDelMeb(row)"
            >
              删除
            </Button>
          </template>
        </Table>
      </div>
      <!-- <Page
        v-show="groupData.length > 0"
        :total="groupTotal"
        :current.sync="groupApiParams.page"
        :page-size="groupApiParams.pageSize"
        :page-size-opts="[10, 15, 20, 40, 60, 100, 200]"
        show-elevator
        show-total
        show-sizer
        @on-page-size-change="handerGroupPageSize"
        @on-change="handerGroupPages"
      ></Page> -->
    </Modal>
  </div>
</template>
<script>
import { postData, getData } from './api';
export default {
  props: {
    row: Object,
    field: String,
  },
  components: {},
  data() {
    return {
      groupId: '',
      groupColumns: [
        {
          title: '名称',
          key: 'f_realname',
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          width: 100,
        },
      ],
      mebData: [],
      //查询参数
      apiParams: {
        page: 1,
        pageSize: 10,
        pageNo: 1,
        rows: 15,
      },
      //查询参数
      groupApiParams: {
        page: 1,
        pageSize: 9999,
        pageNo: 1,
        rows: 9999,
      },
      merberList: null, //全部成员
      transferOfficeModel: false, //控制转办选择弹窗
      transferOfficeMeb: '', //控制转办弹窗
      groupList: [], //群组list
      tableLoading: false, //表格loding
      groupTotal: 0,
      groupData: [],
      tmpMebList: [], //临时储存成员
    };
  },
  watch: {
    // 监听parentValue的变化
    row() {
      this.init();
    },
  },
  created() {},
  activated() {
    try {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDelData();
      }
    } catch (error) {}
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {},
    // 添加成员
    handleChangeMeb(e) {
      // 确保 e 和 e.value 是有效的
      if (!e || !e.value) {
        console.error('无效的事件对象或缺少值:', e);
        return;
      }

      // 查找匹配的成员数据
      const tmpData = this.mebData.find((item) => item.f_id === e.value);

      // 如果没有找到匹配的成员数据，输出错误并退出
      if (!tmpData) {
        console.error('未找到对应的成员数据，f_id:', e.value);
        return;
      }

      // 检查 groupData 中是否已存在该成员
      const isExisting = this.groupData.some(
        (item) => item.f_id === tmpData.f_id,
      );

      // 如果 groupData 中不存在该成员，添加到数组中
      if (!isExisting) {
        this.groupData.push(tmpData);
      } else {
        console.warn('成员已存在于 groupData 中:', tmpData);
      }
    },
    //删除成员
    handleDelMeb(row) {
      this.groupData = this.groupData.filter((item) => item.f_id !== row.f_id);
    },
    openGroupModal() {
      this.groupApiParams = {
        page: 1,
        pageSize: 9999,
        pageNo: 1,
        rows: 9999,
      };
      delete this.groupApiParams.groupidlist;
      this.transferOfficeModel = true;
      this.groupId = '';
      this.groupData = [];
      this.transferOfficeMeb = '';
      this.tmpMebList = '';
      this.getData();
      this.getMebList();
    },
    async getMebList() {
      var res = await getData(
        '/admin/UserControl/GetUserCheckList',
        this.mebApiParams,
        '查询任务主数据',
      );
      if (res.data.success) {
        this.mebData = res.data.data;
      } else {
        this.$message.error(res.data.msg);
        this.tableLoading = false;
      }
    },
    //群主人员跳转页面跳转页数
    handerGroupPages(page) {
      this.groupApiParams.page = page;
      this.getGroupDetailsInfo();
    },
    //群主人员跳转页面改变页数大小
    handerGroupPageSize(pageSize) {
      this.groupApiParams.pageSize = pageSize;
      this.getGroupDetailsInfo();
    },
    handleSearchGroup() {
      this.groupApiParams.groupidlist = this.groupId;
      this.getGroupDetailsInfo();
    },
    async getData() {
      //方法-查询
      var res = await postData('/admin/Posting/GetGroupInfo', this.apiParams);
      if (res.data.success) {
        this.groupList = res.data.data;
      } else {
        this.$message.error(res.data.msg);
      }
      this.tableLoading = false;
    },
    //查询群主人员列表
    async getGroupDetailsInfo() {
      this.transferOfficeMeb = '';
      this.tableLoading = true;
      var res = await postData(
        '/admin/Posting/GetGroupDetailsInfo',
        this.groupApiParams,
      );
      if (res.data.success) {
        this.groupData = res.data.data;
        this.groupTotal = res.data.count;
        this.tableLoading = false;
      } else {
        this.$message.error(res.data.msg);
        this.tableLoading = false;
      }
    },
    //转发
    async hendelTransferOffice() {
      let submitList = [];
      this.groupData.map((itme) => {
        submitList.push(itme.f_id);
      });
      let res = await postData(
        '/admin/Posting/AddReceiving',
        {
          groupidlist: submitList,
          different_table_id: this.row[this.field],
          menu_url: this.$route.path,
          // dispatchesuserlist: this.transferOfficeMeb,
        },
        '查询用户列表',
      );
      if (res.data.success) {
        this.transferOfficeMeb = '';
        this.$message.success(res.data.msg);
      } else {
        this.transferOfficeMeb = '';
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>
<style lang="less"></style>
